module.exports = __webpack_public_path__ + "img/payment-issue.5cf6820.png";